import { features } from '@/mocks/siteData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            为什么选择我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">五大核心优势，打造最硬核的影视吃瓜体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feature, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/60 rounded-xl p-5 md:p-6 text-center hover:border-primary-200 transition-colors"
            >
              <div className="w-12 h-12 mx-auto mb-4 bg-primary-100 rounded-xl flex items-center justify-center">
                <i className={`${feature.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}